import Vue from 'vue'
import DateFormat from './dateFormat'
import NumberFormat from './numberFormat'
import fileSize from './fileSize'
import StringFormatter from './stringFormatter'
import DateString from './dateString'
import CategoryToString from './categoryIdToString'
import CoverageStatus from './coverageStatus'

Vue.filter('dateFormat', DateFormat)
Vue.filter('numberFormat', NumberFormat)
Vue.filter('fileSize', fileSize)
Vue.filter('StringFormatter', StringFormatter)
Vue.filter('DateString', DateString)
Vue.filter('CategoryToString', CategoryToString)
Vue.filter('CoverageStatus', CoverageStatus)
